import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy, limit, where } from 'firebase/firestore';
import { db } from '../firebase';
import './AdminExchanges.css';

const AdminExchanges = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchLogs = async (username = '') => {
    try {
      setLoading(true);
      const exchRef = collection(db, 'exchangeLogs');

      let q;
      if (username.trim() !== '') {
        // Tafuta logs za username maalum
        q = query(exchRef, where('username', '==', username), orderBy('timestamp', 'desc'), limit(50));
      } else {
        // Last 50 exchanges
        q = query(exchRef, orderBy('timestamp', 'desc'), limit(50));
      }

      const snap = await getDocs(q);
      const data = [];
      snap.forEach(doc => data.push(doc.data()));
      setLogs(data);
    } catch (err) {
      console.error('Error fetching exchange logs:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchLogs(searchTerm.trim());
  };

  if (loading) return <p>Loading exchange logs...</p>;
  if (logs.length === 0) return <p>Hakuna exchanges zilizofanyika bado.</p>;

  return (
    <div className="admin-exchanges">
      <h2>Admin - Exchange Logs</h2>

      <form onSubmit={handleSearch} style={{ marginBottom: '1rem' }}>
        <input
          type="text"
          placeholder="Tafuta kwa username..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button type="submit">Search</button>
      </form>

      <table>
        <thead>
          <tr>
            <th>Username</th>
            <th>Type</th>
            <th>From Amount</th>
            <th>To Amount</th>
            <th>Commission</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log, index) => (
            <tr key={index}>
              <td>{log.username}</td>
              <td>{log.type}</td>
              <td>{Number(log.fromAmount).toFixed(2)}</td>
              <td>{Number(log.toAmount).toFixed(2)}</td>
              <td>{Number(log.commission).toFixed(2)}</td>
              <td>
                {log.timestamp?.toDate 
                  ? log.timestamp.toDate().toLocaleString() 
                  : new Date(log.timestamp).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminExchanges;